import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'


const DadosConsumo = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    

    var [energia_id, setEnergia_id] = useState()
    var [refrigeracao, setRefrigeracao] = useState()
    var [tipoServicoRefrigeracao, setTipoServicoRefrigeracao] = useState()
    var [climatizacao, setClimatizacao] = useState()
    var [tipoServicoClimatizacao, setTipoServicoClimatizacao] = useState()
    var [gestaoFaturas_id, setGestaoFaturas_id] = useState()
    var [equipeRealizaGestao, setEquipeRealizaGestao] = useState()
    var [setorPessoas, setSetorPessoas] = useState()
    var [outroSetorPessoas, setOutroSetorPessoas] = useState()
    var [consumoCozinha, setConsumoCozinha] = useState()
    var [operacaoCozinha_id, setOperacaoCozinha_id] = useState()
    var [esterilizacaoTerceirizado, setEsterilizacaoTerceirizado] = useState()
    var [energiaLavanderia, setEnergiaLavanderia] = useState()
    var [consumoEsterilizacao, setConsumoEsterilizacao] = useState()


    function salvaAcoesLideranca() {

        var dataPost = {

            refrigeracao: refrigeracao,
            tipoServicoRefrigeracao: tipoServicoRefrigeracao,
            climatizacao: climatizacao,
            tipoServicoClimatizacao: tipoServicoClimatizacao,
            gestaoFaturas_id: gestaoFaturas_id,
            equipeRealizaGestao: equipeRealizaGestao,
            setorPessoas: setorPessoas,
            outroSetorPessoas: outroSetorPessoas,
            consumoCozinha: consumoCozinha,
            operacaoCozinha_id: operacaoCozinha_id,
            esterilizacaoTerceirizado: esterilizacaoTerceirizado,
            energiaLavanderia: energiaLavanderia,
            consumoEsterilizacao: consumoEsterilizacao,

        }

        //console.log(dataPost)

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (energia_id) {


                        api.put(`energiaConsumo/${energia_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        api.post(`energiaConsumo/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            //console.log(result.data[0].perfilAnual_id, '!!')
                            console.log(result.data)
                            setEnergia_id(result.data[0].energia_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //history.push('/Obrigado')

                
                        }).catch((err) => {
                
                            console.log(err.response)
                
                        })

                    }

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }

    async function carregaEnergiaConsumo() {

        //console.log(adesao_institucional_id, ano)
        //return false

        await api.get(`energiaConsumo/${adesao_institucional_id}/${ano}`).then((result) => {

            //console.log(result.data)

            if (result.data) {


                var data = result.data[0]


                setEnergia_id(data.energia_id)
                setRefrigeracao(data.refrigeracao)
                setTipoServicoRefrigeracao(data.tipoServicoRefrigeracao)
                setClimatizacao(data.climatizacao)
                setTipoServicoClimatizacao(data.tipoServicoClimatizacao)
                setGestaoFaturas_id(data.gestaoFaturas_id)
                setEquipeRealizaGestao(data.equipeRealizaGestao)
                setSetorPessoas(data.setorPessoas)
                setOutroSetorPessoas(data.outroSetorPessoas)
                setConsumoCozinha(data.consumoCozinha)
                setOperacaoCozinha_id(data.operacaoCozinha_id)
                setEsterilizacaoTerceirizado(data.esterilizacaoTerceirizado)
                setEnergiaLavanderia(data.energiaLavanderia)
                setConsumoEsterilizacao(data.consumoEsterilizacao)


            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {


        setEnergia_id()
        setRefrigeracao()
        setTipoServicoRefrigeracao()
        setClimatizacao()
        setTipoServicoClimatizacao()
        setGestaoFaturas_id()
        setEquipeRealizaGestao()
        setSetorPessoas()
        setOutroSetorPessoas()
        setConsumoCozinha()
        setOperacaoCozinha_id()
        
        setEnergiaLavanderia()
        setConsumoEsterilizacao()
        setEsterilizacaoTerceirizado()
        

        if (ano) {

            carregaEnergiaConsumo()

        }

    }, [ano, adesao_institucional_id])



    return (

        <div>

                <div className="row">                               

                   

                    <div className="col-md-12">

                    As informações com (*) são de preenchimento obrigatório

                    <br/><br/>

                    <b>ESTRUTURA DA GESTÃO DE ENERGIA

                    <br/><br/>


                    Equipe Técnica</b>

                    <br/><br/>


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    1. Sua organização recebe serviços (próprios ou terceirizados) com especialização em refrigeração?
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="refrigeracao" onClick={() => setRefrigeracao('P')} checked={ refrigeracao == 'P' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                        Próprio
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="refrigeracao" onClick={() => setRefrigeracao('T')} checked={ refrigeracao == 'T' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Terceirizado (Contratos de médio e longo prazo)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="refrigeracao" onClick={() => setRefrigeracao('D')} checked={ refrigeracao == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Apenas sob demanda (Contratos para serviços pontuais)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="refrigeracao" onClick={() => setRefrigeracao('N')} checked={ refrigeracao == 'N' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Não recebemos estes serviços especializados
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>


                    </div>

                    <div className="col-md-12" style={{ display: refrigeracao == 'N' ? 'table-row' : 'none' }}>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    1.a Caso sua resposta tenha sido o último item "Não recebemos estes serviços especializados" na Pergunta 1 responda a seguinte questão:
                                    <br/><br/>
                                    O serviço não especializado de refrigeração é:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="tipoServicoRefrigeracao" onClick={() => setTipoServicoRefrigeracao('P')} checked={ tipoServicoRefrigeracao == 'P' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                        Próprio
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio"  name="tipoServicoRefrigeracao" onClick={() => setTipoServicoRefrigeracao('T')} checked={ tipoServicoRefrigeracao == 'T' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Terceirizados (Contratos de médio e longo prazo)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="tipoServicoRefrigeracao" onClick={() => setTipoServicoRefrigeracao('D')} checked={ tipoServicoRefrigeracao == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Apenas sob demanda (Contratos para serviços pontuais)
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    2. Sua organização recebe serviços (próprios ou terceirizados) com especialização em climatização?
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="climatizacao"  onClick={() => setClimatizacao('P')} checked={ climatizacao == 'P' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                        Próprio
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="climatizacao"  onClick={() => setClimatizacao('T')} checked={ climatizacao == 'T' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Terceirizados (Contratos de médio e longo prazo)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="climatizacao"  onClick={() => setClimatizacao('D')} checked={ climatizacao == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Apenas sob demanda (Contratos para serviços pontuais)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio"  name="climatizacao"  onClick={() => setClimatizacao('N')} checked={ climatizacao == 'N' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Não recebemos estes serviços especializados
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                    </div>

                    <div className="col-md-12" style={{ display: climatizacao == 'N' ? 'table-row' : 'none' }}>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    2.a  Caso sua resposta tenha sido o último item "Não recebemos estes serviços especializados" na Pergunta 2 responda a seguinte questão:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="tipoServicoClimatizacao"  onClick={() => setTipoServicoClimatizacao('P')} checked={ tipoServicoClimatizacao == 'P' ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                        Próprio
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="tipoServicoClimatizacao"  onClick={() => setTipoServicoClimatizacao('T')} checked={ tipoServicoClimatizacao == 'T' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Terceirizados (Contratos de médio e longo prazo)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="tipoServicoClimatizacao"  onClick={() => setTipoServicoClimatizacao('A')} checked={ tipoServicoClimatizacao == 'A' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Apenas sob demanda (Contratos para serviços pontuais)
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>

                    </div>

                    <div className="col-md-12">

                        <br/>

                        <b>Gestão de Faturas de Energia</b>
                        <br/><br/>

                    

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    3. Como é realizada a gestão das faturas e do consumo de energia?
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoFaturas_id"  onClick={() => setGestaoFaturas_id(1)} checked={ gestaoFaturas_id == 1 ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Apenas com a organização e o pagamento das faturas.
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoFaturas_id"  onClick={() => setGestaoFaturas_id(2)} checked={ gestaoFaturas_id == 2 ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Com organização e pagamento das faturas, sendo seus valores e o consumo acompanhados internamente; nenhum sistema de medição local (além do contador da concessionária).
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoFaturas_id"  onClick={() => setGestaoFaturas_id(3)} checked={ gestaoFaturas_id == 3 ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Com organização e pagamento das faturas, sendo seus valores e o consumo acompanhados internamente; com sistema de medição local (além do contador da concessionária).
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoFaturas_id"  onClick={() => setGestaoFaturas_id(4)} checked={ gestaoFaturas_id == 4 ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Com organização e pagamento das faturas, sendo seus valores e o consumo acompanhados internamente; com sistema de automação e controle.
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    4. A equipe que realiza essa gestão e acompanhamento é:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="equipeRealizaGestao"  onClick={() => setEquipeRealizaGestao('P')} checked={ equipeRealizaGestao == 'P' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Própria
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="equipeRealizaGestao"  onClick={() => setEquipeRealizaGestao('T')} checked={ equipeRealizaGestao == 'T' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Terceirizada
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    5. Sobre o setor das pessoas que compõe essa equipe:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="setorPessoas"  onClick={() => setSetorPessoas('E')} checked={ setorPessoas == 'E' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Engenharia
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="setorPessoas"  onClick={() => setSetorPessoas('A')} checked={ setorPessoas == 'A' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Administrativo
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="setorPessoas"  onClick={() => setSetorPessoas('O')} checked={ setorPessoas == 'O' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Outro
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td colspan="2">
                                        
                                        <input type="text" style={{ backgroundColor: '#FFF'}} value={outroSetorPessoas} onChange={event => setOutroSetorPessoas(event.target.value)} disabled />
                                        
                                    </td>
                                    
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>



                    <div className="col-md-12">

                        <br/>

                        <b>Alocação de consumo de energia de áreas/serviços especiais</b>
                        <br/><br/>


                        Nota: Mesmo terceirizado, o consumo de energia de áreas e serviços especiais, ao funcionar dentro do hospital, podem estar embutidos no consumo da unidade.

                        <br/><br/>

                    

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    6. O consumo de energia da cozinha é:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="consumoCozinha" onClick={() => setConsumoCozinha('A')} checked={ consumoCozinha == 'A' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Atrelado ao consumo de energia da unidade
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="consumoCozinha" onClick={() => setConsumoCozinha('D')} checked={ consumoCozinha == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Dissociado do consumo de energia da unidade
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    7. O modelo de operação da cozinha pode ser descrito como:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="operacaoCozinha_id" onClick={() => setOperacaoCozinha_id(1)} checked={ operacaoCozinha_id == 1 ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Recebe as refeições prontas apenas para distribuição
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="operacaoCozinha_id" onClick={() => setOperacaoCozinha_id(2)} checked={ operacaoCozinha_id == 2 ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Recebe alimentos semipreparados para finalização na unidade
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="operacaoCozinha_id" onClick={() => setOperacaoCozinha_id(3)} checked={ operacaoCozinha_id == 3 ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Realiza todo ou a maior parte do preparo na unidade
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    8. O consumo de energia da lavanderia é:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio"  name="energiaLavanderia" onClick={() => setEnergiaLavanderia('A')} checked={ energiaLavanderia == 'A' ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Atrelado ao consumo de enegia da unidade
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio"  name="energiaLavanderia" onClick={() => setEnergiaLavanderia('D')} checked={ energiaLavanderia == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Dissociado do consumo de energia da unidade
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    9. O serviço de esterelização de materiais é terceirizado?
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="esterilizacaoTerceirizado" onClick={() => setEsterilizacaoTerceirizado(true)} checked={ esterilizacaoTerceirizado ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Sim
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="esterilizacaoTerceirizado" onClick={() => setEsterilizacaoTerceirizado(false)} checked={ !esterilizacaoTerceirizado && esterilizacaoTerceirizado != null ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Não
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    10. O consumo da área de esterelização de materiais é:
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="consumoEsterilizacao" onClick={() => setConsumoEsterilizacao('A')} checked={ consumoEsterilizacao == 'A' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Atrelado ao consumo de energia da unidade
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="consumoEsterilizacao" onClick={() => setConsumoEsterilizacao('D')} checked={ consumoEsterilizacao == 'D' ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Dissociado do consumo de energia da unidade
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>


                </div>



                

        </div>
    )

}

export default DadosConsumo